import "./Scss/main.scss";
import "./JavaScript/main.js";

console.log("HKS TYPO3 14 Site Package Loaded");
